import Grid from "@mui/material/Unstable_Grid2";
import React, { useCallback } from "react";
import { Button, Box, Link, Modal } from "@mui/material";
import "../../OrganisationSettings/Currencies/Currencies.scss";
import { useNavigate } from "react-router-dom";

import UGTable from "../../../../../../Supporting files/UGTable/UGTable";
import DepartmentInformation from "./DepartmentInformation/DepartmentInformation";
import EditDepartmentInformation from "./EditDepartmentInformation/EditDepartmentInformaion";
// import AddCurrency from "./AddCurrency";

const Department = () => {
  const [departmentInformation, setDepartmentInformation] =
    React.useState(false);
  const [editdepartmentInformation, setEditDepartmentInformation] =
    React.useState(false);
  const [deleteStatus, setDeleteStatus] = React.useState(false);
  const navigate = useNavigate();

  //Table Data
  const [columns, setColumns] = React.useState([
    {
      field: "departmentid",
      headerName: "Department ID",
      width: 200,
      check_status: true,
      renderCell: (ValueFormatterParams: any) => {
        const { row } = ValueFormatterParams;
        return (
          <p
            style={{
              cursor: "pointer",
              fontWeight: "400",
              color: "#2166AA",
              textDecoration: "none",
            }}
            onClick={() => {
              setEditDepartmentInformation(true);
            }}
          >
            EV001
          </p>
        );
      },
    },
    {
      field: "departmentname",
      headerName: "Department Name",
      width: 300,
      check_status: true,
    },

    {
      field: "creationdate",
      headerName: "Creation Date",
      width: 200,
      check_status: true,
    },
    {
      field: "creationtime",
      headerName: "Creation Time",
      width: 200,
      check_status: true,
    },
  ]);
  const rows = [
    {
      id: 0,
      departmentid: "EV001",
      departmentname: "Pre-Sales",
      creationdate: "22 - Mar - 2023",
      creationtime: "12:00 hrs",
    },
    {
      id: 1,
      departmentid: "EV002",
      departmentname: "Pre-Sales",
      creationdate: "22 - Mar - 2023",
      creationtime: "12:00 hrs",
    },
    {
      id: 2,
      departmentid: "EV003",
      departmentname: "Pre-Sales",
      creationdate: "22 - Mar - 2023",
      creationtime: "12:00 hrs",
    },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };
  return (
    <Grid container spacing={2} className="currunciesWrapper">
      <DepartmentInformation
        open_status={departmentInformation}
        attrName={setDepartmentInformation}
        value_update={updateMasterState}
      />
      <EditDepartmentInformation
        open_status={editdepartmentInformation}
        attrName={setEditDepartmentInformation}
        value_update={updateMasterState}
      />
      <Grid xs={4}>
        <h3 className="mb-0">Department</h3>
      </Grid>

      <Grid xs={8} className="text-right">
        <div className="buttons">
          <Link
            underline="none"
            className="greenBtn addfile"
            onClick={() => {
              setDepartmentInformation(true);
            }}
          >
            Create
          </Link>
          <Link
            underline="none"
            className="blueBtn edit"
            onClick={() => {
              setEditDepartmentInformation(true);
            }}
          >
            Edit
          </Link>
          <Link
            underline="none"
            className="redBtn delete"
            onClick={() => {
              setDeleteStatus(true);
            }}
          >
            Remove
          </Link>
        </div>
      </Grid>
      <Grid xs={12}>
        <div style={{ height: 400 }}>
          <UGTable
            header_data={columns}
            data={rows}
            value_update={updateMasterState}
            attrName={"UGTable"}
          />
        </div>
      </Grid>
      <Modal open={deleteStatus} className="modalWrapper">
        <Box className="modalInner">
          <Grid container spacing={1}>
            <Grid xs={12}>
              <Link
                className="close-button"
                onClick={() => {
                  setDeleteStatus(false);
                }}
              />
              <h5 className="popup-heading">Are you sure ?</h5>
            </Grid>
            <Grid xs={12}>
              <Link className="md-link" underline="none">
                You are want to delete 5 Users.
              </Link>
            </Grid>
            <Grid xs={12} className="ctaBtn" textAlign={"center"}>
              <Button variant="contained" className="submitBtn">
                Yes, Delete
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Grid>
  );
};

export default Department;
